import { render, staticRenderFns } from "./SendDollNew.vue?vue&type=template&id=39178210&scoped=true"
import script from "./SendDollNew.vue?vue&type=script&lang=js"
export * from "./SendDollNew.vue?vue&type=script&lang=js"
import style0 from "./SendDollNew.vue?vue&type=style&index=0&id=39178210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39178210",
  null
  
)

export default component.exports